module.exports = __webpack_public_path__ + "py.svg?cd42b3353ab80e1410e3ac11bac299e6";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/py.svg
// module id = 1112
// module chunks = 27